import React, { useEffect, useState } from 'react';
import { useLocation, useNavigate } from 'react-router-dom';
import { useNotificationStore } from '@/stores/notifications';
import logo from '@/assets/logo.png';
import { Spinner } from '@/components/Elements';
import { useSlackCallback } from '@/features/settings/api/integrations/slackCallback.api';

const SlackCallback = () => {
  const location = useLocation();
  const navigate = useNavigate();
  const slackCallback = useSlackCallback();
  const { addNotification } = useNotificationStore();

  let url = new URL(window.location.href);
  let params = new URLSearchParams(url.search);

  const code = params.get('code');
  const state = params.get('state');

  const [isLoading, setIsLoading] = useState(true);
  const [isConnected, setIsConnected] = useState(false);

  const performslackCallback = async () => {
    const response = await slackCallback.mutateAsync({ code, state });

    if (response['success'] === true) {
      addNotification({
        type: 'success',
        title: 'Slack Connection Successful',
      });
      setIsConnected(true);
      setIsLoading(false);
    } else {
      setIsConnected(false);
      setIsLoading(false);
    }
  };

  useEffect(() => {
    if (code === null || state === null) {
      navigate('/deep-dives');
    }
    performslackCallback();
  }, []);

  return (
    <div className="flex items-center justify-center h-screen">
      {isLoading ? (
        <Spinner />
      ) : (
        <div className="flex flex-col items-center gap-4">
          <img src={logo} className={`w-6 h-7`} />
          {isConnected ? (
            <p>Connected to Slack</p>
          ) : (
            <p>Connection unsuccessful</p>
          )}
        </div>
      )}
    </div>
  );
};

export default SlackCallback;
